import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Button, Modal, Row, Col, Form, OverlayTrigger } from "react-bootstrap";
import { MdFilterList, MdAddCircle, MdEdit, MdDelete } from "react-icons/md";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import loading from "../../../assets/images/common/loading.gif";
import AppDataGrid from "../../../components/common/AppDataGrid";


const formatDateDDMMYYYY = (dateValue) => {
    if (!dateValue) return "";

    const date = new Date(dateValue);
    if (isNaN(date)) return dateValue;

    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${dd}-${mm}-${yyyy}`;
};



const TcsMaster = () => {
    const [routes, setRoutes] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();
    const [showFilterModal, setShowFilterModal] = useState(false);
    const handleShowFilterModal = () => setShowFilterModal(true);
    const handleCloseFilterModal = () => setShowFilterModal(false);
    const [isLoading, setIsLoading] = useState(true);

    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem("user");
    const userObj = userData ? JSON.parse(userData) : {};

    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge", "School Admin"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());

    const [form, setForm] = useState({
        tcs_master_id: "",
        effective_date: "",
        with_pan_percentage: "",
        without_pan_percentage: "",

        school_id: userObj?.school_id || ""
    });

    const [filter, setFilter] = useState({
        tcs_master_id: 0,
        effective_date_from: "",
        effective_date_to: "",
        with_pan_percentage: "",
        without_pan_percentage: ""
    });


    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setForm((prevForm) => ({
            ...prevForm,
            [id]: value
        }));
    };

    const fetchTcsMaster = async () => {
        try {
            const response = await axios.post(`${baseUrl}/finance/searchtcs_master/`, {
                action: "READ",
                school_id: userObj.school_id
            });
            setRoutes(response.data);
        } catch (error) {
            console.error("Error fetching route locations:", error);
        }
    };

    // const handleFilterSearch = async () => {
    //     try {
    //         const response = await axios.post(`${baseUrl}/routelocation/`, {
    //             action: "FILTER",
    //             school_id: userObj.school_id,
    //             ...filter
    //         });
    //         setRoutes(response.data);
    //         setShowFilterModal(false);
    //     } catch (error) {
    //         console.error("Error filtering route locations:", error);
    //     }
    // };

    const handleFilterSearch = async (e) => {
        setShowFilterModal(false);
        e.preventDefault();

        const payload = {
            tcs_master_id: 0,
            effective_date_from: filter.effective_date_from || null,
            effective_date_to: filter.effective_date_from || null,
            with_pan_percentage: filter.with_pan_percentage || 0,
            without_pan_percentage: filter.without_pan_percentage || 0
        };

        try {
            const response = await axios.post(
                `${baseUrl}/finance/searchtcs_master/`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            setRoutes(response.data || []);
            setShowFilterModal(false);
            // 


        } catch (error) {
            console.error("Error filtering TCS:", error);
        }
    };




    const handleEditClick = (tcs_master_id) => {
        const selected = routes.find(r => r.tcs_master_id === tcs_master_id);
        if (selected) {
            navigate("/finance/tcs/add", { state: { routeData: selected } });
        } else {
            console.error(`Route Location ID ${tcs_master_id} not found`);
        }
    };



    const searchableColumns = [
        (row) => formatDateDDMMYYYY(row.effective_date),
        (row) => row.with_pan_percentage,
        (row) => row.without_pan_percentage
    ];

    const filteredRecords = (routes || []).filter((item) =>
        searchableColumns.some((selector) => {
            const value = selector(item);
            const stringValue = String(value || '').toUpperCase().replace(/[-\s]+/g, '');
            const normalizedQuery = searchQuery.toUpperCase().replace(/[-\s]+/g, '');
            return stringValue.includes(normalizedQuery);
        })
    );

    const columns = [
        {
            field: "effective_date",
            headerName: "Effective Date",
            flex: 1,
            renderCell: (params) => {
                const formattedDate = formatDateDDMMYYYY(params.value);
                return (
                    <Tooltip title={formattedDate}>
                        <span className="cell-wrap">{formattedDate}</span>
                    </Tooltip>
                );
            }
        }
        ,
        {
            field: "with_pan_percentage",
            headerName: "Pan%",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },
        {
            field: "without_pan_percentage",
            headerName: "Without Pan%",
            flex: 1,
            renderCell: (params) => (
                <Tooltip title={params.value || ""}>
                    <span className="cell-wrap">{params.value}</span>
                </Tooltip>
            )
        },

        ...(canSubmit
            ? [
                {
                    field: "actions",
                    headerName: "Actions",
                    flex: 1,
                    sortable: false,
                    renderCell: (params) =>
                        params.row.tcs_master_id !== "No records found" ? (
                            <div className="tableActions">
                                <Tooltip title="Edit" arrow>
                                    <span
                                        className="commonActionIcons"
                                        onClick={() => handleEditClick(params.row.tcs_master_id)}
                                    >
                                        <MdEdit />
                                    </span>
                                </Tooltip>

                            </div>
                        ) : null
                }
            ]
            : [])
    ];

    const handleReset = async (e) => {
        e.preventDefault();

        setFilter({
            tcs_master_id: 0,
            effective_date_from: "",
            effective_date_to: "",
            with_pan_percentage: "",
            without_pan_percentage: ""
        });

        await fetchTcsMaster();

    };


    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    useEffect(() => {
        setIsLoading(true);
        fetchTcsMaster().finally(() => setIsLoading(false));
    }, []);

    return (
        <div className="pageBody">
            <ToastContainer />
            <div className="commonDataTableHead">
                <div className="d-flex justify-content-between align-items-center w-100">
                    <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                        <h6 className="commonTableTitle">TCS Master</h6>
                    </div>
                    <div>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            className="searchInput"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="d-flex align-items-center" style={{ gap: 6 }}>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Filter</Tooltip>}>
                            <Button className="secondaryBtn" variant="secondary" onClick={handleShowFilterModal}>
                                <MdFilterList />
                            </Button>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip-top">Add</Tooltip>}>
                            <Button className="primaryBtn" variant="primary" onClick={() => navigate("/finance/tcs/add")}>
                                <MdAddCircle />
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            </div>

            <div className="commonTable height100">
                <div className="tableBody">
                    {isLoading ? (
                        <div className="loadingContainer">
                            <img src={loading} alt="Loading..." className="loadingGif" />
                        </div>
                    ) : (
                        <AppDataGrid
                            rows={filteredRecords}
                            columns={columns}
                            getRowId={(r) => r.tcs_master_id}
                            showToolbar={false}
                            pagination
                            pageSizeOptions={[10, 20, 50]}
                            density="compact"
                            maxHeight={500}
                        />
                    )}
                </div>
            </div>

            {/* Filter Modal */}
            <Modal show={showFilterModal} onHide={handleCloseFilterModal} className="commonFilterModal">
                <Modal.Header closeButton className="modalHeaderFixed">
                    <Modal.Title>Filter</Modal.Title>
                </Modal.Header>
                <Modal.Body className="modalBodyScrollable">
                    <Row>
                        <Col xs={12}>
                            <div className="commonInput">
                                <Form.Group>
                                    <Form.Label>Effective Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={filter.effective_date_from}
                                        onChange={(e) =>
                                            setFilter({ ...filter, effective_date_from: e.target.value })
                                        }
                                    />
                                </Form.Group>

                                <Form.Group className="mt-2">
                                    <Form.Label>With PAN %</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={filter.with_pan_percentage}
                                        onChange={(e) =>
                                            setFilter({ ...filter, with_pan_percentage: e.target.value })
                                        }
                                    />
                                </Form.Group>

                                <Form.Group className="mt-2">
                                    <Form.Label>Without PAN %</Form.Label>
                                    <Form.Control
                                        type="number"
                                        value={filter.without_pan_percentage}
                                        onChange={(e) =>
                                            setFilter({ ...filter, without_pan_percentage: e.target.value })
                                        }
                                    />
                                </Form.Group>

                            </div>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="modalFooterFixed">
                    <Button variant="secondary" className="btn-info clearBtn me-2" onClick={handleReset}>
                        Reset
                    </Button>
                    <div>
                        <Button variant="secondary" className="btn-danger secondaryBtn me-2" onClick={handleCloseFilterModal}>
                            Cancel
                        </Button>
                        <Button
                            variant="primary"
                            className="btn-success primaryBtn"
                            onClick={handleFilterSearch}
                        >
                            Search
                        </Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default TcsMaster;
